export const API_URI = process.env.REACT_APP_API_URI || "/graphql/";
export const TOKEN_STORAGE_KEY = "token";
export const OAUTH_REDIRECT_URL = `${window.location.origin}/oauth/`;
export const LAST_VISITED_TEAM_KEY = "lastVisitedTeam";
